module.exports = __webpack_public_path__ + "media/images/features/4/og-image-1e44ee056ba77e73115baa91c7bd3dc9.jpg";